import { getLodop } from './lodopFuncs';
import axios from 'axios';
let lodop = null;

export const initLodop = () => {
  if (!getLodop()) {
    console.error('打印控件未安装，请于下载专区安装');
    if (confirm('打印控件未安装，请于下载专区安装')) {
      window.open('http://www.lodop.net/download.html');
    }
    return;
  }
  lodop = getLodop();
  if (lodop.VERSION < '6.2.2.6') {
    console.error('打印控件未安装，请于下载专区安装').error('打印服务需升级，请于下载专区升级');
    if (confirm('打印服务需升级，请于下载专区升级')) {
      window.open('http://www.lodop.net/download.html');
    }
    return;
  }
  lodop.PRINT_INIT('qsyy'); // 打印初始化 PRINT_INIT(打印任务名)
  lodop.SET_LICENSES("","D184AFDA373FC5370C17536373889488AB3","","");
  return lodop;
};

/**
 * 加载pdf 并转为base64
 * @param {string} pdfUrl[pdf的链接]
 */
export const getFileBase64 = async (pdfUrl) => {
  let fileData = null;
  try {
    fileData = await axios({
      method: 'get',
      url: pdfUrl, // 请求地址
      responseType: 'blob' // 指明服务器返回的数据类型
    });
  } catch {
    fileData = null;
  }
  return new Promise((resolve, reject) => {
    if (fileData && fileData.data) {
      const file = new Blob([fileData.data], { type: 'application/pdf' });
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    } else {
      reject('文件读取错误');
    }
  });
};

/**
 * 打印pdf
 * @param {string} pdfUrl[pdf的链接]
 */
export const lodopFdfBase64 = (pdfUrl) => {
  const lodop = initLodop();
  if (!lodop) return;
  getFileBase64(pdfUrl).then((res) => {
    lodop.PRINT_INITA(0, 0, '220mm', '140mm', '二分');
    lodop.SET_PRINT_PAGESIZE(1, '220mm', '140mm', 'sdf'); // 设置纸张大小
    lodop.ADD_PRINT_PDF(0, 20, '100%', '100%', res ? res.split('data:application/pdf;base64,')[1] : '');
    const printName = sessionStorage.getItem('printNameHtml') || null; // 获取默认打印机
    if (lodop.SET_PRINTER_INDEX(printName)) {
      lodop.PRINTA(); // 静默打印
    } else {
      lodop.PREVIEW(); // 预览
    }
  });
};

/**
 * 打印html
 * @param {string} html[html内容]
 */
export const lodopHtmlA4 = (html) => {
  const width = '210mm';
  const height = '297mm';
  const lodop = initLodop();
  if (!lodop) return;
  // lodop.SET_PRINT_STYLEA(0,"ItemType",1);
  lodop.PRINT_INITA(0, 0, width, height, '打印');
  lodop.SET_PRINT_PAGESIZE(1, width, height, ''); // 设置纸张大小
  lodop.ADD_PRINT_TABLE(0, 45, width, height, html ? html : '');
  const printName = sessionStorage.getItem('printNameHtml') || null; // 获取默认打印机
  if (lodop.SET_PRINTER_INDEX(printName)) {
    lodop.PRINTA(); // 静默打印
  } else {
    lodop.PREVIEW(); // 预览
  }
};

/**
 * 打印html
 * @param {string} html[html内容]
 */
export const lodopHtmlTwoPart = (html) => {
  const lodop = initLodop();
  if (!lodop) return;
  // lodop.SET_PRINT_STYLEA(0,"ItemType",1);
  lodop.PRINT_INITA(0, 0, '210mm', '139mm', '打印');
  lodop.SET_PRINT_PAGESIZE(1, '210mm', '139mm', ''); // 设置纸张大小
  const reg = /^(?=.*ttbody)(?=.*tthead)(?=.*ttfoot).*$/ims.test(html);
  if (reg) {
    var el = document.createElement('html');
    el.innerHTML = html;
  
    lodop.ADD_PRINT_TABLE('35mm', '5mm', '200mm', '80mm', el.getElementsByClassName('ttbody')[0].innerHTML); //内容
    lodop.SET_PRINT_STYLEA(0, 'Vorient', 3);
    lodop.ADD_PRINT_HTM(0, '5mm', '200mm', '42mm', el.getElementsByClassName('tthead')[0].innerHTML); //表头
  
    lodop.SET_PRINT_STYLEA(0, 'ItemType', 1);
    lodop.SET_PRINT_STYLEA(0, 'LinkedItem', 1);
  
    lodop.ADD_PRINT_HTM('123mm', '-3mm', '200mm', '', el.getElementsByClassName('ttfoot')[0].innerHTML); //footer
    lodop.SET_PRINT_STYLEA(0, 'ItemType', 1);
    lodop.SET_PRINT_STYLEA(0, 'LinkedItem', 1);
  } else {
    lodop.ADD_PRINT_TABLE(0, 15, '210mm', '139mm', html ? html.replace('90%', '100%') : '');
  }
  const printName = sessionStorage.getItem('printNameHtml') || null; // 获取默认打印机
  if (lodop.SET_PRINTER_INDEX(printName)) {
    lodop.PRINTA(); // 静默打印
  } else {
    lodop.PREVIEW(); // 预览
  }
};

/**
 * 打印html
 * @param {string} html[html内容]
 */
export const lodopHtmlThirdPart = (html) => {
  const lodop = initLodop();
  if (!lodop) return;
  lodop.PRINT_INITA(0, 0, '210mm', '93mm', '打印');
  lodop.SET_PRINT_PAGESIZE(1, '210mm', '93mm', ''); // 设置纸张大小
  const reg = /^(?=.*ttbody)(?=.*tthead)(?=.*ttfoot).*$/ims.test(html);
  if(reg) {
    var el = document.createElement('html');
    el.innerHTML = html;
  
    lodop.ADD_PRINT_TABLE('35mm', '5mm', '200mm', '40mm', el.getElementsByClassName('ttbody')[0].innerHTML); //内容
    lodop.SET_PRINT_STYLEA(0, 'Vorient', 3);
    lodop.ADD_PRINT_HTM(0, '5mm', '200mm', '42mm', el.getElementsByClassName('tthead')[0].innerHTML); //表头
  
    lodop.SET_PRINT_STYLEA(0, 'ItemType', 1);
    lodop.SET_PRINT_STYLEA(0, 'LinkedItem', 1);
  
    lodop.ADD_PRINT_HTM('80mm', '-3mm', '200mm', '', el.getElementsByClassName('ttfoot')[0].innerHTML); //footer
    lodop.SET_PRINT_STYLEA(0, 'ItemType', 1);
    lodop.SET_PRINT_STYLEA(0, 'LinkedItem', 1);
  } else {
    lodop.ADD_PRINT_TABLE('0', 15, '210mm', '93mm', html ? html.replace('90%', '100%') : '');
  }
  lodop.SET_PRINT_MODE('AUTO_CLOSE_PREWINDOW', 1); //打印后自动关闭预览窗口

  const printName = sessionStorage.getItem('printNameHtml') || null; // 获取默认打印机
  if (lodop.SET_PRINTER_INDEX(printName)) {
    lodop.PRINTA(); // 静默打印
  } else {
    lodop.PREVIEW(); // 预览
  }
};

//销售二等分
export const lodopHtmlTradeOrderTwoPart = (html) => {
  const lodop = initLodop();
  if (!lodop) return;
  console.log(html);
  var el = document.createElement('html');
  el.innerHTML = html;

  lodop.PRINT_INITA(0, 0, '210mm', '139mm', '打印');
  lodop.SET_PRINT_PAGESIZE(1, '210mm', '139mm', ''); // 设置纸张大小

  lodop.ADD_PRINT_TABLE('32mm', '4.5mm', '200mm', '85mm', el.getElementsByClassName('ttbody')[0].innerHTML); //内容
  lodop.SET_PRINT_STYLEA(0, 'Vorient', 3);
  lodop.ADD_PRINT_HTM('10mm', '5mm', '200mm', '22mm', el.getElementsByClassName('tthead')[0].innerHTML); //表头

  lodop.SET_PRINT_STYLEA(0, 'ItemType', 1);
  lodop.SET_PRINT_STYLEA(0, 'LinkedItem', 1);

  lodop.ADD_PRINT_HTM('117mm', '5mm', '200mm', '', el.getElementsByClassName('ttfooter')[0].innerHTML); //footer
  lodop.SET_PRINT_STYLEA(0, 'ItemType', 1);
  lodop.SET_PRINT_STYLEA(0, 'LinkedItem', 1);
  const printName = sessionStorage.getItem('printNameHtml') || null; // 获取默认打印机
  if (lodop.SET_PRINTER_INDEX(printName)) {
    lodop.PRINTA(); // 静默打印
  } else {
    lodop.PREVIEW(); // 预览
  }
};

//销售三等分
export const lodopHtmlTradeOrderThirdPart = (html) => {
  const lodop = initLodop();
  if (!lodop) return;
  console.log(html);
  var el = document.createElement('html');
  el.innerHTML = html;
  lodop.PRINT_INITA(0, 0, '210mm', '93mm', '打印');
  lodop.SET_PRINT_PAGESIZE(1, '210mm', '93mm', ''); // 设置纸张大小

  lodop.ADD_PRINT_TABLE('22mm', '4.5mm', '200mm', '55mm', el.getElementsByClassName('ttbody')[0].innerHTML); //内容
  lodop.SET_PRINT_STYLEA(0, 'Vorient', 3);
  lodop.ADD_PRINT_HTM('0', '5mm', '200mm', '22mm', el.getElementsByClassName('tthead')[0].innerHTML); //表头

  lodop.SET_PRINT_STYLEA(0, 'ItemType', 1);
  lodop.SET_PRINT_STYLEA(0, 'LinkedItem', 1);

  lodop.ADD_PRINT_HTM('77mm', '5mm', '200mm', '', el.getElementsByClassName('ttfooter')[0].innerHTML); //footer
  lodop.SET_PRINT_STYLEA(0, 'ItemType', 1);
  lodop.SET_PRINT_STYLEA(0, 'LinkedItem', 1);
  const printName = sessionStorage.getItem('printNameHtml') || null; // 获取默认打印机
  if (lodop.SET_PRINTER_INDEX(printName)) {
    lodop.PRINTA(); // 静默打印
  } else {
    lodop.PREVIEW(); // 预览
  }
};
//销售A4
export const lodopHtmlTradeOrderA4 = (html) => {
  const lodop = initLodop();
  if (!lodop) return;
  console.log(html);
  var el = document.createElement('html');
  el.innerHTML = html;
  lodop.PRINT_INITA(0, 0, '210mm', '297mm', '打印');
  lodop.SET_PRINT_PAGESIZE(1, '210mm', '297mm', 'A4'); // 设置纸张大小

  lodop.ADD_PRINT_TABLE('22mm', '0', '100%', '260mm', el.getElementsByClassName('ttbody')[0].innerHTML); //内容
  lodop.SET_PRINT_STYLEA(0, 'Vorient', 3);
  lodop.ADD_PRINT_HTM('0', '0.5mm', '100%', '22mm', el.getElementsByClassName('tthead')[0].innerHTML); //表头

  lodop.SET_PRINT_STYLEA(0, 'ItemType', 1);
  lodop.SET_PRINT_STYLEA(0, 'LinkedItem', 1);

  lodop.ADD_PRINT_HTM('282mm', '0.5mm', '100%', '', el.getElementsByClassName('ttfooter')[0].innerHTML); //footer
  lodop.SET_PRINT_STYLEA(0, 'ItemType', 1);
  lodop.SET_PRINT_STYLEA(0, 'LinkedItem', 1);
  const printName = sessionStorage.getItem('printNameHtml') || null; // 获取默认打印机
  if (lodop.SET_PRINTER_INDEX(printName)) {
    lodop.PRINTA(); // 静默打印
  } else {
    lodop.PREVIEW(); // 预览
  }
};

export const lodopHtmlBarCode = (html, condition, lodopObj) => {
  const width = '60mm';
  const height = '30mm';
  let lodop = lodopObj || initLodop();
  if (!lodop) return;
  lodop.PRINT_INITA(0, 0, width, height, '打印');
  lodop.SET_PRINT_PAGESIZE(1, width, height, ''); // 设置纸张大小
  lodop.ADD_PRINT_HTM(0, 0, width, height, html ? html : '');
  const printName = sessionStorage.getItem('printNameHtml') || null; // 获取默认打印机
  lodop.SET_PRINTER_INDEX(printName)
  console.log(printName);
  if (condition === 'print') {
    lodop.PRINT(); // 静默打印
  } else {
    lodop.PREVIEW(); // 预览
  }
};

function demoDownloadPDF (url) {
  if (!/^https?:/i.test(url)) return url
  let xhr = null
  if (window.XMLHttpRequest) xhr = new XMLHttpRequest()
  else xhr = new window.ActiveXObject('MSXML2.XMLHTTP')
  xhr.open('GET', url, false) // 同步方式
  if (xhr.overrideMimeType) {
    try {
      xhr.responseType = 'arraybuffer'
      var arrybuffer = true
    } catch (err) {
      xhr.overrideMimeType('text/plain; charset=x-user-defined')
    }
  }
  xhr.send(null)
  var data = xhr.response || xhr.responseBody
  let dataArray = null
  if (typeof Uint8Array !== 'undefined') {
    if (arrybuffer) dataArray = new Uint8Array(data)
    else {
      dataArray = new Uint8Array(data.length)
      for (var i = 0; i < dataArray.length; i++) {
        dataArray[i] = data.charCodeAt(i)
      }
    }
  } else dataArray = window.VBS_BinaryToArray(data).toArray() // 兼容IE低版本
  return demoGetBASE64(dataArray)
}


function demoGetBASE64 (dataArray) {
  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
  var strData = ''
  for (var i = 0, ii = dataArray.length; i < ii; i += 3) {
    if (isNaN(dataArray[i])) break
    var b1 = dataArray[i] & 0xff
    var b2 = dataArray[i + 1] & 0xff
    var b3 = dataArray[i + 2] & 0xff
    var d1 = b1 >> 2
    var d2 = ((b1 & 3) << 4) | (b2 >> 4)
    var d3 = i + 1 < ii ? ((b2 & 0xf) << 2) | (b3 >> 6) : 64
    var d4 = i + 2 < ii ? b3 & 0x3f : 64
    strData +=
      digits.substring(d1, d1 + 1) +
      digits.substring(d2, d2 + 1) +
      digits.substring(d3, d3 + 1) +
      digits.substring(d4, d4 + 1)
  }
  return strData
}

export const lodopPDFBarCode = (html, condition, lodopObj) => {
  const width = '60mm';
  const height = '30mm';
  let lodop = lodopObj || initLodop();
  if (!lodop) return;
  lodop.PRINT_INITA(0, 0, width, height, '打印');
  lodop.SET_PRINT_PAGESIZE(1, width, height, ''); // 设置纸张大小
  lodop.ADD_PRINT_PDF(0, 0, width, height, html ? demoDownloadPDF(html) : '');
  const printName = sessionStorage.getItem('printNameHtml') || null; // 获取默认打印机
  lodop.SET_PRINTER_INDEX(printName)
  console.log(printName);
  if (condition === 'print') {
    lodop.PRINT(); // 静默打印
  } else {
    lodop.PREVIEW(); // 预览
  }
};

